const secondWay = {
    '2': {
        cardId: 'colleaguesVacations',
        reaction: {
            modalId: 'runOverAll',
            actions: [
                {
                    type: 'addCards',
                    data: ['colleagueAgree', 'managerArbiting']
                },
                {
                    type: 'removeCards',
                    data: ['managerDoesntRemember']
                }
            ]
        },
        next: ['2.1', '2.2']
    },
    '2.1': {
        cardId: 'colleagueAgree',
        reaction: {
            rndEnding: {
                type: 'lose',
                message: `Антон запланировал отпуск с семьёй и не может перенести. И хотя вы помните, что в начале года Антон планировал другие даты, поделать ничего не можете: у него отпуск уже согласован, а одновременно уйти вам не позволяет работа.<br/>
                Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон  заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.`
            },
            modalId: 'youAreLucky'
        },
        next: ['2.1.1', '2.1.2']
    },
    '2.2': {
        cardId: 'managerArbiting',
        reaction: {
            modalId: 'managerSendYouOff'
        },
        next: ['2.1']
    },
    '2.1.1': {
        cardId: 'leaveApplication',
        reaction: {
            actions: [
                {
                    type: 'addCards',
                    data: ['managerSignature', 'hrDepartment']
                }
            ]
        },
        next: ['2.1.1.1', '2.1.1.2']
    },
    '2.1.2': {
        cardId: 'datesAgreement',
        reaction: {
            modalId: 'datesDoNotOverlap'
        },
        next: ['2.1.2.1']
    },
    '2.2.1': {
        cardId: 'vacationSchedule',
        reaction: {
            modalId: 'notActualGraph'
        },
        next: ['2.1']
    },
    '2.1.1.1': {
        cardId: 'managerSignature',
        reaction: {
            modalId: 'datesDoNotOverlap'
        },
        next: ['2.1.1.1.1']
    },
    '2.1.1.2': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrFoundFault',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication']
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.1.2.1']
    },
    '2.1.2.1': {
        cardId: 'leaveApplication',
        reaction: {
            actions: [
                {
                    type: 'addCards',
                    data: ['managerSignature', 'hrDepartment']
                }
            ]
        },
        next: ['2.1.1.1' , '2.1.2.1.1']
    },
    '2.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'unpaidLeave',
            actions: [
                {
                    type: 'addCards',
                    data: ['managerAdditionalVacationsAgree']
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.1.1.1.1']
    },
    '2.1.1.2.1': {
        cardId: 'rewriteApplication',
        next: ['2.1.1.2.1.1', '2.1.1.2.1.1.1']
    },
    '2.1.2.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrFoundFault',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication']
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.2.1.1.1']
    },
    '2.1.1.1.1.1': {
        cardId: 'managerAdditionalVacationsAgree',
        reaction: {
            rndEnding: {
                type: 'lose',
                message: `Руководитель рушит мечты об отпуске: «Раз положенное отгуляли, то не могу отпустить. Задач много, сами понимаете». Что ж, руководитель действительно может отказать в отпуске за свой счёт, если вы просто хотите отдохнуть и не имеете на это веских причин. Но если согласовывать отпуск заранее, может удастся договориться.<br/>
                Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.`
            },
            modalId: 'unpaidLeaveIsOk',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication']
                }
            ]
        },
        next: ['2.1.1.1.1.1.1', '2.1.1.1.1.1.2']
    },
    '2.1.1.2.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrOneEye',
            actions: [
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.1.2.1.1.1']
    },
    '2.1.2.1.1.1': {
        cardId: 'rewriteApplication',
        next: ['2.1.2.1.1.1.1']
    },
    '2.1.1.1.1.1.1': {
        cardId: 'rewriteApplication',
        reaction: {
            actions: [
                {
                    type: 'addCards',
                    data: ['managerSignature']
                }
            ]
        },
        next: ['2.1.1.1.1.1.1.1']
    },
    '2.1.1.1.1.1.2': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'youAreTired',
            actions: [
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.1.1.1.1.1']
    },
    '2.1.1.2.1.1.1': {
        cardId: 'managerSignature',
        reaction: {
            modalId: 'bossIsAway',
            actions: [
                {
                    type: 'addCards',
                    data: ['findSignatureOfAnotherManager']
                }
            ]
        },
        next: ['2.1.1.2.1.1.1.1']
    },
    '2.1.2.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'hrOneEye',
            actions: [
                {
                    type: 'addCards',
                    data: ['dismissal']
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.2.1.1.1.1.1', '2.1.2.1.1.1.1.2']
    },
    '2.1.1.1.1.1.1.1': {
        cardId: 'managerSignature',
        next: ['2.1.1.1.1.1.1.1.1']
    },
    '2.1.1.2.1.1.1.1': {
        cardId: 'findSignatureOfAnotherManager',
        reaction: {
            modalId: 'foundAnotherManager',
            actions: [
                {
                    type: 'addCards',
                    data: ['rewriteApplication']
                }
            ]
        },
        next: ['2.1.1.2.1.1.1.1.1']
    },
    '2.1.2.1.1.1.1.1': {
        cardId: 'managerSignature',
        next: ['2.1.2.1.1.1.1.1.1']
    },
    '2.1.2.1.1.1.1.2': {
        cardId: 'dismissal',
        ending: {
            type: 'lose',
            message: `Что ж, понимаем вас. Работать в компании, где так сложно оформить отпуск, не очень приятно: когда кадровые вопросы отнимают так много времени, сил на основные задачи уже не остаётся. Надеемся, на вашем следующем месте работы будет установлен EmployeeGate.<br/>
        Осталось написать заявление на увольнение. Но это уже совсем другая игра...`
        }
    },
    '2.1.1.1.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            ending: {
                type: 'win',
                message: `Ура, собирайте чемоданы! Кажется, вы уже сталкивались со всеми сложностями при оформлении отпуска и научились на своих ошибках.<br/>
                Упростите жизнь себе и всем сотрудникам компании, внедрив EmployeeGate. Например, с личным кабинетом не нужно искать шаблон заявления и высчитывать дату подачи, сотрудники всегда видят, кто замещает руководителя, а руководители видят график отпусков своих подчинённых. Так высокооплачиваемые специалисты не будут тратить рабочее время на формальности.`
            }
        }
    },
    '2.1.1.2.1.1.1.1.1': {
        cardId: 'rewriteApplication',
        next: ['2.1.1.2.1.1.1.1.1.1']
    },
    '2.1.2.1.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            modalId: 'unpaidLeave',
            actions: [
                {
                    type: 'addCards',
                    data: ['managerAdditionalVacationsAgree']
                },
                { type: 'returnToBacklog' }
            ]
        },
        next: ['2.1.2.1.1.1.1.1.1.1']
    },
    '2.1.1.2.1.1.1.1.1.1': {
        cardId: 'hrDepartment',
        reaction: {
            ending: {
                type: 'win',
                message: `Ура, собирайте чемоданы! Кажется, вы уже сталкивались со всеми сложностями при оформлении отпуска и научились на своих ошибках.<br/>
                Упростите жизнь себе и всем сотрудникам компании, внедрив EmployeeGate. Например, с личным кабинетом не нужно искать шаблон заявления и высчитывать дату подачи, сотрудники всегда видят, кто замещает руководителя, а руководители видят график отпусков своих подчинённых. Так высокооплачиваемые специалисты не будут тратить рабочее время на формальности.`
            },
        }
    },
    '2.1.2.1.1.1.1.1.1.1': {
        cardId: 'managerAdditionalVacationsAgree',
        reaction: {
            ending: {
                type: 'lose',
                message: `Руководитель не против отпустить вас в дополнительный отпуск, ведь вы много работали и заслужили. Но для этого нужно переписать заявление и отправить его в HR. Жаль, что вы узнали об этом так поздно: рабочее время закончилось и все ушли отдыхать. А в компании строго соблюдают правило, что отпуск должен быть написан за 14 календарных дней.<br/>
                Желаем, чтобы в вашей компании появился EmployeeGate, ведь с ним всё гораздо быстрее: не нужно искать шаблон заявления и высчитывать дату подачи — всё просто заполняется в личном кабинете. А ещё вы всегда видите, кто замещает руководителя, а руководители видят график отпусков своих подчинённых.`
            }
        }
    }
    
}

export default secondWay